export * from "./exceptions";
export * from "./HttpClient";
export * from "./utils";

export enum BundleManifestComponentType {
  BOOTLOADER = "bootloader",
  APPLICATION = "application",
  SE = "se",
}

export enum BundleManifestComponentPackage {
  FIDO = "fido",
  PIV = "piv",
}

export enum BundleManifestArtifactId {
  BINARY = "binary",
  LOGIC = "logic",
  INTERFACE = "interface",
  CREDENTIAL_MANAGER = "credential_manager",
}

export const SEMVER_PATTERN_FULL = /^\d+\.\d+\.\d+$/;
export const SEMVER_PATTERN_REDUCED = /^\d+\.\d+$/;

// Matches model_numbers table
export const COMPONENT_APPLICATION = 2;
export const COMPONENT_BOOTLOADER = 3;
export const COMPONENT_SE_FIDO = 4;
export const COMPONENT_SE_PIV = 5;
export const COMPONENT_BUNDLE = 6;
export const COMPONENT_DEFAULT = COMPONENT_BUNDLE;

// Matches data_types table
export const DATA_TYPE_APPLICATION_PROD = 17;
export const DATA_TYPE_BOOTLOADER_PROD = 23;
export const DATA_TYPE_SE_FIDO_PACKAGE_PROD = 25;
export const DATA_TYPE_SE_PIV_PACKAGE_PROD = 27;
export const DATA_TYPE_BUNDLE_MANIFEST = 29;
export const DATA_TYPE_SE_FIDO_LOGIC_PROD = 30;
export const DATA_TYPE_SE_PIV_LOGIC_PROD = 32;
